<script>
import Vue from 'vue'
import { BCardTitle, BCard, BButton, BBadge } from 'bootstrap-vue'
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import {
    CandidateListDetails, RoHSDetails, POPsDetails, MaxConcentrationExemptionDetails
} from "@/views/product/components/product-card/composition/substance/details/edit";
import {SubstanceApi} from "@core/api";
import {SubstanceLists} from "@/libs/substance";
import {getAllSubstanceLists} from "@core/domain/substance";

export default {
    components: {
        BCardTitle, BCard, BButton, AppCollapseItem, AppCollapse, CandidateListDetails, RoHSDetails, POPsDetails,
        MaxConcentrationExemptionDetails, BBadge
    },
    props: {
        compactView: {
            type: Boolean,
            default: false
        },
        substance: {
            type: Object,
            default() {
                return {
                    substance: {
                        title: ''
                    },
                    details: {
                        list: {},
                        details: []
                    }
                };
            }
        }
    },
    data() {
        let concentrationRangeOptionsMap = {};
        Object.keys(this.substance.details).forEach(key => {
            if (!concentrationRangeOptionsMap[key]) {
                concentrationRangeOptionsMap[key] = Vue.observable([]);
            }
        });
        const map = {};
        map[SubstanceLists.CANDIDATE_LIST] = 'CandidateListDetails';
        map[SubstanceLists.ROHS] = 'RoHSDetails';
        map[SubstanceLists.POPS] = 'POPsDetails';
        return {
            substanceListComponentMap: map,
            concentrationRangeOptions: concentrationRangeOptionsMap,
            substanceLists: [],
        }
    },
    methods: {
        exclude() {
            this.$emit('exclude', this.substance);
        },
        onChange(listKey, details) {
            this.substance.details[listKey].details = details;
            this.$emit('change', this.substance, details, listKey);
        },
        retrieveLists() {
            SubstanceApi
                .lists()
                .then(r => {
                    r.data.forEach(l => {
                        this.concentrationRangeOptions[l.key] = l.concentrationRange;
                    });
                });
        }
    },
    computed: {
        substanceDetails() {
            const result = {};
            Object.keys(this.substance.details).forEach(key => {
                const list = this.substanceLists.find(l => l.key === key);
                if (list && list.isExternal(this.substance.substance)) {
                    return;
                }
                result[key] = this.substance.details[key];
            });
            return result;
        }
    },
    created() {
        this.retrieveLists();
        getAllSubstanceLists().then(lists => {
            this.substanceLists = lists;

            lists.forEach(list => {
                if (!this.substanceListComponentMap.hasOwnProperty(list.key)) {
                    this.substanceListComponentMap[list.key] = 'MaxConcentrationExemptionDetails';
                }
            });
        });
    }
}
</script>

<template>
    <b-card
        no-body
        bg-variant="default"
        border-variant="light"
    >
        <div class="card-header bg-light">
            <b-card-title>{{ substance.substance.title }}</b-card-title>
            <div class="text-right">
                <b-badge class="mr-1" v-if="substance.substance.cas !== '-'">CAS: {{ substance.substance.cas }}</b-badge>
                <b-badge class="mr-2" v-if="substance.substance.ec !== '-'">EC: {{ substance.substance.ec }}</b-badge>
                <b-button
                    variant="gradient-danger"
                    class="btn-icon"
                    size="sm"
                    @click="exclude"
                >
                    <feather-icon icon="MinusIcon" />
                </b-button>
            </div>
        </div>
        <AppCollapse
            type="border"
            class="m-2"
        >
            <AppCollapseItem
                v-for="(details, listKey) in substanceDetails"
                :title="details.list.title"
                is-visible
                :is-collapsible="false"
            >
                <component
                    v-if="substanceListComponentMap.hasOwnProperty(listKey)"
                    :is="substanceListComponentMap[listKey]"
                    @change="onChange"
                    v-bind="{compactView: compactView, listKey: listKey, substanceList: details.list, substance: substance.substance, details: details.details, concentrationRangeIntervalOptions: concentrationRangeOptions[listKey]}"
                />
            </AppCollapseItem>
        </AppCollapse>
    </b-card>
</template>
